import { Component, OnInit, HostListener } from "@angular/core";
import { BrowserCompatibilityService } from "./browser-compatibility.service";
import { ReleaseLicenseService } from "./shared/license/release-license.service";
import { CloudUserStorageService } from "./shared/user/cloud-user-storage.service";
import { ReleaseLicenseConfigurationService } from "./shared/configuration/auth/logout/release-license/release-license-configuration.service";
import { Router } from "@angular/router";
import { BrowserInactivityService } from "./service/browser-inactivity.service";
import { TabSessionStorageService } from "./shared/tabs/tab-session-storage.service";
import { LogoutService } from "./shared/auth/logout.service";
import { TimeoutStorageService } from "./shared/timeout/timeout-storage.service";
import { TokenStorageService } from "./shared/auth/token/token-storage.service";

@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "HBSIWebPortal";

  browserIsCompatible;
  
  /* Avoid the use of the bfcache when using the backbutton to navigate back to the page from somewhere else.
     Necessary for Chrome - so that after logging out, clicking back doesn't display the previous content.
     Note: This will only attach the event-listener After the very first pageshow event - which is ok ...
     ... since the persisted property will be false in this case - but in the case of the page being cached - the listener will be hooked up */
  @HostListener('window:pageshow', ['$event'])
  onPageShow(event) {
    if (event.persisted) {
      window.location.reload();
    }
  }

  constructor(
    private router:Router,
    private browserCompatibilityService: BrowserCompatibilityService,
    private browserInactivityService:BrowserInactivityService,
    private tabSessionStorageService: TabSessionStorageService,
    private logoutService: LogoutService,
    private tokenStorageService:TokenStorageService,
    private timeoutStorageService:TimeoutStorageService
  ) {
    
    browserInactivityService.setInterrupts(); // provide sources that will "interrupt" aka provide events indicating the user is active


    browserInactivityService.onIdleStart().subscribe(() => {
      this.router.navigate(['/session-timeout']);
    });
    // do something when the user is no longer idle
    browserInactivityService.onIdleEnd().subscribe(() => {
      this.reset()
    });
    // do something when the user has timed out
    browserInactivityService.onItemTimeout().subscribe(() => {
    
      this.logout();
    });


    // set keepalive parameters, omit if not using keepalive
    browserInactivityService.keepAlive(); // will ping at this interval while not idle, in seconds
    browserInactivityService.onPing().subscribe(()=>{}); // do something when it pings
  }
  reset() {
    // we'll call this method when we want to start/reset the idle process
    // reset any component state and be sure to call idle.watch()
    this.browserInactivityService.watch();
  }
  logout() {
    this.invalidateStoredTabSession();
    this.logoutService.logout();
  }
  invalidateStoredTabSession() {
     (this.tabSessionStorageService.tabSession = null);
  }
  ngOnInit(): void {
    let idleTimeout:any=this.timeoutStorageService.loadIdleTimeout();
    this.browserInactivityService.loadBrowserInactivity(idleTimeout);
   
    this.browserIsCompatible = this.browserCompatibilityService.isBrowserCompatible();
  }
}
